<template>
  <v-container fluid class="mt-2">
    <v-row align="center" class="mb-3">
      <v-col cols="auto" class="py-0">
        <v-menu offset-y v-model="filterMenuOpen" content-class="mdl-sort-menu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" :disabled="portionLoading" class="mx-1 my-1 tonal-button">
              <span>{{ (errorFilterValues.find(v => v.value === errorFilter) || {}).text }}</span>
              <v-icon right>{{ filterMenuOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="item in errorFilterValues"
              :key="item.value"
              @click="errorFilter = item.value"
            >
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col class="py-0">
        <v-text-field
          :placeholder="$t('rights.search')"
          v-model="searchQuery"
          :disabled="portionLoading"
          @keydown.enter.prevent="doSearch"
          @click:append="doSearch"
          append-icon="mdi-magnify"
          filled
          rounded
          hide-details
          class="t-search-query mb-0" />
      </v-col>

      <v-col v-if="!$vuetify.breakpoint.mobile" cols="12" lg="auto" class="d-flex flex-wrap align-center py-0 pr-0">

          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="menuScope">
              <v-tooltip top>
                <template v-slot:activator="tooltipScope">
                  <v-btn v-on="{ ...menuScope.on, ...tooltipScope.on }" :disabled="portionLoading" class="mx-1 my-1 tonal-button">
                    <v-icon left>mdi-dots-vertical</v-icon>
                    <span>{{ $t('rights.columnsButton') }}</span>
                  </v-btn>
                </template>
                <span>{{ $t('rights.columnsButtonTooltip') }}</span>
              </v-tooltip>
            </template>

            <v-list dense>
              <v-list-item v-for="col in additionalColumns" :key="col.value">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="selectedColumns.includes(col.value)"
                    @change="toggleColumnSelect(col.value)"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  {{ col.text }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" :disabled="portionLoading" class="mx-1 my-1 tonal-button">
                <v-icon left>mdi-tray-arrow-up</v-icon>
                <span>{{ $t('staging.import') }}</span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="uploadPopup = true">
                <v-list-item-icon><v-icon>mdi-file-excel</v-icon></v-list-item-icon>
                <v-list-item-title>{{ $t('rights.upload_xls') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="spotifyPopup = true">
                <v-list-item-icon><v-icon>mdi-link</v-icon></v-list-item-icon>
                <v-list-item-title>{{ $t('rights.upload_spotify') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-on="tooltipScope.on" :disabled="portionLoading" class="mx-1 my-1 tonal-button" @click="reloadItems">
                <v-icon left>mdi-reload</v-icon>
                <span>{{ $t('staging.claimform.reload') }}</span>
              </v-btn>
            </template>
            <span>{{ $t('staging.claimform.reloadTooltip') }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="tooltipScope">
              <v-btn v-bind="tooltipScope.attrs" v-on="tooltipScope.on" :disabled="portionLoading" class="mx-1 my-1" color="primary" @click="addRightVisible = true">
                <v-icon left>mdi-plus-circle-outline</v-icon>
                <span class="text--white">{{ $t('rights.create') }}</span>
              </v-btn>
            </template>
            <span>{{ $t('rights.createTooltip') }}</span>
          </v-tooltip>

      </v-col>
    </v-row>

    <v-row v-if="!$vuetify.breakpoint.mobile" class="mt-4 mb-6">
      <v-col class="d-flex flex-wrap justify-end align-center py-0 pr-0">

        <v-tooltip top>
          <template v-slot:activator="tooltipScope">
            <v-btn outlined v-on="tooltipScope.on" class="mx-1 my-1" :disabled="portionLoading || checkedItems.length === 0" @click="onCreateClaimForm">
              <v-icon left>mdi-check</v-icon>
              <span>{{ $t('staging.claimform.button') }}</span>
            </v-btn>
          </template>
          <span>{{ $t('staging.claimform.buttonTooltip') }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="tooltipScope">
            <v-btn outlined v-on="tooltipScope.on" class="mx-1 my-1" @click="editFormVisible = true" :disabled="portionLoading || checkedItems.length === 0">
              <v-icon left>mdi-pencil-outline</v-icon>
              <span>{{ $t('rights.edit') }}</span>
            </v-btn>
          </template>
          <span>{{ $t('rights.editTooltip') }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="tooltipScope">
            <v-btn outlined v-on="tooltipScope.on" class="mx-1 my-1" :disabled="portionLoading || checkedItems.length === 0" @click="onRevokeItems">
              <v-icon left>mdi-undo</v-icon>
              <span>{{ $t('staging.revoke') }}</span>
            </v-btn>
          </template>
          <span>{{ $t('staging.revokeTooltip') }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="tooltipScope">
            <v-btn outlined v-on="tooltipScope.on" class="mx-1 my-1" @click="onRemoveItems" :disabled="portionLoading || checkedItems.length === 0">
              <v-icon left>mdi-trash-can-outline</v-icon>
              <span>{{ $t('staging.remove') }}</span>
            </v-btn>
          </template>
          <span>{{ $t('staging.removeTooltip') }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="tooltipScope">
            <v-btn outlined v-on="tooltipScope.on" :disabled="portionLoading || downloading || Lget(staging, 'list.length', 0) === 0" class="mx-1 my-1" @click="onDownloadItems">
              <v-icon v-if="downloading" left>mdi-loading mdi-spin</v-icon>
              <v-icon v-else left>mdi-tray-arrow-down</v-icon>
              <span>{{ $t('rights.download') }}</span>
            </v-btn>
          </template>
          <span>{{ $t('rights.downloadTooltip') }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="tooltipScope">
            <v-btn outlined color="error" v-on="tooltipScope.on" class="mx-1 my-1" @click="onRemoveAllItems" :disabled="portionLoading || Lget(staging, 'list.length', 0) === 0">
              <v-icon left>mdi-trash-can-outline</v-icon>
              <span>{{ $t('staging.removeAll') }}</span>
            </v-btn>
          </template>
          <span>{{ $t('staging.removeAllTooltip') }}</span>
        </v-tooltip>

      </v-col>
    </v-row>

    <mobile-data-list
      v-if="$vuetify.breakpoint.mobile"
      v-model="checkedItems"
      :items="mobileItems"
      :loading="portionLoading"
      :items-per-page="25"
      :footer-props="{ itemsPerPageOptions: [] }"
      :headers="mobileHeaders"
      show-select
      single-expand
      @expand="onMobileExpand"
    >
      <template #item.revoke="{ item }">
        {{ String(item.revoke) === 'true' ? 'Ja' : 'Nej' }}
      </template>
      <template #item.type="{ item }">
        <v-icon v-if="String(item.type) === '1'" small>mdi-volume-high</v-icon>
        <v-icon v-else-if="String(item.type) === '2'" small>mdi-video</v-icon>
        <span v-else>{{ item.type }}</span>
      </template>
      <template #item.internationalCollection="{ item }">
        <v-icon small>{{ item.internationalCollection ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline' }}</v-icon>
      </template>
      <template #item.hasError="{ item }">
        <v-icon v-if="!item.hasError" color="success" small>mdi-check</v-icon>
        <span v-else class="d-flex align-center" style="gap: 4px">
          <v-icon color="error" small>mdi-alert</v-icon>
          <span v-if="errors[String(item.id)]" class="text-caption error--text">
            <span v-for="err in errors[String(item.id)]" :key="err.en">{{ err[$i18n.locale] }} </span>
          </span>
          <v-progress-circular v-else indeterminate size="12" width="2" color="primary" />
        </span>
      </template>
    </mobile-data-list>

    <RightsTable
      v-else
      :continuos-amount="!staging.finished"
      :portion-loading="portionLoading"
      :checked-items.sync="checkedItems"
      :items="rightsList"
      :displayed-columns="displayedColumns"
      :errors="errors"
      :total-count="staging.totalCount"
      @load-errors="loadErrors"
      columnSortOrderStore="stagingAreaColumnsOrder"
    />

    <div v-if="$vuetify.breakpoint.mobile" class="sa-mobile-actions">
      <div class="sa-mobile-actions__row">
        <v-btn color="primary" :disabled="portionLoading" @click="addRightVisible = true" class="sa-mobile-actions__create">
          <v-icon left>mdi-plus-circle-outline</v-icon>
          {{ $t('rights.create') }}
        </v-btn>
        <v-menu top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn outlined v-on="on" v-bind="attrs" :disabled="portionLoading">
              <v-icon left>mdi-dots-vertical</v-icon>{{ $t('app.more') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="onCreateClaimForm" :disabled="portionLoading || checkedItems.length === 0">
              <v-list-item-icon><v-icon>mdi-check</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('staging.claimform.button') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="editFormVisible = true" :disabled="portionLoading || checkedItems.length === 0">
              <v-list-item-icon><v-icon>mdi-pencil-outline</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('rights.edit') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onRevokeItems" :disabled="portionLoading || checkedItems.length === 0">
              <v-list-item-icon><v-icon>mdi-undo</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('staging.revoke') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onRemoveItems" :disabled="portionLoading || checkedItems.length === 0">
              <v-list-item-icon><v-icon>mdi-trash-can-outline</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('staging.remove') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onRemoveAllItems" :disabled="portionLoading || Lget(staging, 'list.length', 0) === 0" class="error--text">
              <v-list-item-icon><v-icon color="error">mdi-trash-can-outline</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('staging.removeAll') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onDownloadItems" :disabled="portionLoading || downloading || Lget(staging, 'list.length', 0) === 0">
              <v-list-item-icon><v-icon>{{ downloading ? 'mdi-loading mdi-spin' : 'mdi-tray-arrow-down' }}</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('rights.download') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="sa-mobile-actions__row">
        <v-menu top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" :disabled="portionLoading" class="tonal-button sa-mobile-actions__import">
              <v-icon left>mdi-tray-arrow-up</v-icon>
              {{ $t('staging.import') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="uploadPopup = true">
              <v-list-item-icon><v-icon>mdi-file-excel</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('rights.upload_xls') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="spotifyPopup = true">
              <v-list-item-icon><v-icon>mdi-link</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('rights.upload_spotify') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn :disabled="portionLoading" class="tonal-button" @click="reloadItems">
          <v-icon left>mdi-reload</v-icon>
          {{ $t('staging.claimform.reload') }}
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="uploadPopup" width="500px" :max-width="$vuetify.breakpoint.mobile ? '95%' : '30%'">
      <AddRightExcelForm
        v-if="uploadPopup"
        :loading="uploadLoading"
        @save="onExcelPopupSave"
        @cancel="uploadPopup = false"
      />
    </v-dialog>

    <v-dialog width="600px" :max-width="$vuetify.breakpoint.mobile ? '95%' : '30%'" v-model="spotifyPopup">
      <AddRightSpotifyForm
        v-if="spotifyPopup"
        @cancel="spotifyPopup = false"
        @save="onSpotifyPopupFinished"
      />
    </v-dialog>


    <v-dialog v-model="editFormVisible" :max-width="$vuetify.breakpoint.mobile ? '95%' : '60%'" :persistent="!$vuetify.breakpoint.mobile">
      <EditRightForm
        v-if="editFormVisible"
        :items="checkedItems"
        :actions-loading="editInProcess"
        :actions-loading-progress="editProgress.value"
        @close="editFormVisible = false"
        @save="onRightsEdit"
      >

      </EditRightForm>
    </v-dialog>

    <v-dialog :width="$vuetify.breakpoint.mobile ? '95%' : '50%'" :value="editInProcess">
      <v-card>
        <v-card-text>
          <span>{{ $t('staging.edit.inProcess') }}</span>
          <v-progress-linear color="secondary" :indeterminate="editProgress.value < 0" :value="editProgress.value * 100"/>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog :width="$vuetify.breakpoint.mobile ? '95%' : '50%'" max-width="1000px" v-model="addRightVisible">
      <AddRightForm
        v-if="addRightVisible"
        @cancel="addRightVisible = false"
        @save="onCreateRightFinished"
      />
    </v-dialog>

  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import RightsholderInitedDataDrivenMixin from "@/components/mixins/RightsholderInitedDataDrivenMixin";
import RightsTable from "@/components/rights/RightsTable";
import MobileDataList from "@/components/common/MobileDataList";
import DebounceSearchLauncherMixin from "@/components/mixins/DebounceSearchLauncherMixin";
import EditRightForm from "@/components/rights/EditRightForm";
import CreateRightButtonMixin from "@/components/mixins/CreateRightButtonMixin";
import SelectedColumnsStore from "@/components/mixins/SelectedColumnsStoreMixin";
import AddRightForm from "@/components/rights/AddRightForm";
import AddRightSpotifyForm from "@/components/rights/AddRightSpotifyForm";
import AddRightExcelForm from "@/components/rights/AddRightExcelForm";
import downloadFile from "@/utils/downloadFile";
import Lget from 'lodash/get'

export default {
  name: 'StagingArea',
  components: {AddRightForm, EditRightForm, RightsTable, MobileDataList, AddRightSpotifyForm, AddRightExcelForm},
  data() {
    return {
      uploadPopup: false,
      portionLoading: false,
      checkedItems: [],
      errorFilter: 'all',
      filterMenuOpen: false,
      errors: {},
      editFormVisible: false,
      editInProcess: false,
      editProgress: {
        value: 0
      },
      selectedColumns: [],
      selectedColumnsStore: "stagingAreaColumns",
      uploadLoading: false,
      columnHeadings: [],
      spotifyPopup: false,
      downloading: false,
    }
  },
  mixins: [SelectedColumnsStore, DebounceSearchLauncherMixin, RightsholderInitedDataDrivenMixin, CreateRightButtonMixin],
  computed: {
    ...mapGetters('app', ['staging','currentRightsholder']),
    rightsList() {
      if (!this.staging.list) {
        return [];
      }
      const list = this.staging.list;

      const noErrors = this.errorFilter === 'no-errors';
      return this.errorFilter === 'all' ? list : list.filter(({hasError}) => (noErrors ? !hasError : hasError));
    },
    allColumns() {
      return [
        'revoke',
        'rowNumber',
        'hasError',
        'type',
        'isrc',
        'spnr',
        'artistName',
        'title',
        'countryCode',
        'companyCountryCode',
        'secondaryCountryCode',
        'year',
        'claimStartDate',
        'claimEndDate',
        'labelName',
        'status',
        'version',
        'externalId',
        'grp',
        'file'
      ].concat(this.currentRightsholder.internationalCollectionAllowed ? ['internationalCollection'] : []);
    },
    errorFilterValues() {
      return ['all', 'errors', 'no-errors'].map((value) => ({value, text: this.$t(`staging.errorFilters.${value}`)}))
    },

    displayedColumns() {
      return this.allColumns.filter((col) => (this.additionalColumns.some(({value}) => value === col) ? this.selectedColumns.includes(col) : true));
    },

    additionalColumns() {
      const getCol = (value) => ({value, text: this.$t(`rights.columns.${value}`)})
      return ['rowNumber', 'spnr', 'version', 'year', 'companyCountryCode', 'secondaryCountryCode', 'labelName', 'grp', 'file'].map(getCol);
    },

    mobileItems() {
      return this.rightsList.filter(Boolean);
    },

    mobileHeaders() {
      const h = (value) => ({ value, text: this.$t(`rights.columns.${value}`) });
      const pinned = { title: 'primary', artistName: 'secondary', isrc: 'tertiary' };
      const stacked = new Set(['internationalCollection']);
      return this.allColumns.map(value => ({
        ...h(value),
        ...(pinned[value] ? { mobile: pinned[value] } : {}),
        ...(stacked.has(value) ? { stacked: true } : {}),
      }));
    },
  },

  methods: {

    // For Lodash get i template
    Lget,

    // Mixin override
    reloadItems() {
      this.loadItems(true);
    },

    // Do search
    doSearch() {
      this.loadItems(true);
    },

    // Override
    searchQueryUpdated() {
      // this.loadItems(true);
    },

    loadItems(force) {
      if (!this.portionLoading) {
        this.portionLoading = true;
        return this.$store.dispatch('app/loadStagingRows', {
          reload: force,
          search: this.searchQuery
        })
          .then(res => {
            if (res && res.headings) {
              this.columnHeadings = res.headings.reduce((res, curr) => ({...res, ...curr}), {});
            }
          })
          .catch((err) => {
            this.$toast(err.message)
          })
          .finally(() => {
            this.portionLoading = false;
          })
      }
      return Promise.resolve('Already loading')
    },

    onRemoveItems() {
      this.$dialog.confirm({
        text: this.$t("staging.confirmDelete", [this.checkedItems.length])
      })
        .then((response) => {
          if (response) {
            this.removeItems();
          }
        })
    },

    onRemoveAllItems() {
      this.$dialog.confirm({
        text: this.$t("staging.confirmDelete", [this.staging.list.length])
      })
        .then((response) => {
          if (response) {
            this.removeAllItems();
          }
        })
    },

    removeAllItems() {
      this.$store.dispatch('app/removeStagingRows', this.staging.list)
        .then(() => {
          this.checkedItems = [];
        })
    },

    removeItems() {
      this.$store.dispatch('app/removeStagingRows', this.checkedItems)
        .then(() => {
          this.checkedItems = [];
        })
    },

    onRevokeItems() {
      this.$dialog.confirm({
        text: this.$t('staging.confirmRevoke')
      })
        .then((res) => {
          if (res) {
            this.revokeItems();
          }
        })
    },

    revokeItems() {
      this.$store.dispatch('app/revokeRights', {items: this.checkedItems})
        .then(() => {
          this.reloadItems();
          this.checkedItems = [];
        })
    },

    toggleColumnSelect(col) {
      if (this.selectedColumns.includes(col)) {
        this.selectedColumns = this.selectedColumns.filter(c => c !== col);
      } else {
        this.selectedColumns.push(col);
      }
    },

    loadErrors(item) {
      const id = String(item.id);
      if (item.errors) {
        return;
      }
      item.errors = [];
      const field = (err, lang) => this.columnHeadings[err.field]?.label[lang] || err.field;
      const displayedErrors = item.error.map((err) => ({en: `[${field(err, 'En')}] ${err.errormsg.en}`, sv: `[${field(err, 'Sv')}] ${err.errormsg.sv}` }));
      this.$set(this.errors, id, displayedErrors);
    },

    onRightsEdit(data) {
      const launchEdit = (items) => {
        this.editInProcess = true;
        this.editProgress = {value: 0};
        return this.$store.dispatch('app/editRightsList', {items, progressObservable: this.editProgress})
          .then((res) => {
            setTimeout(() => {
              this.checkedItems = [];
              this.editFormVisible = false;
              this.editInProcess = false;
              this.$toast(this.$t('staging.edit.success', [res.data.count]));
              this.reloadItems();
            }, 1000);
          })
          .catch((err) => {
            console.error(err);
            this.$toast(this.$t('staging.edit.error'));
            this.editInProcess = false;
          })
      }

      switch (data.mode) {
        case 'list': {
          if (data.items.length) {
            launchEdit(data.items);
          } else {
            this.$toast(this.$t('rights.editForm.noItems'))
          }
          break;
        }
        case 'field': {
          if (Object.keys(data.item).length > 0) {
            const list = data.targets.map(({ityp, isrc, spnr}) => ({ityp, isrc, spnr, ...data.item}));
            launchEdit(list);
          } else {
            this.$toast(this.$t('rights.editForm.noChangesToApply'))
          }
        }
      }
    },

    onCreateClaimForm() {
      this.$dialog.prompt({
        title: this.$t('staging.claimform.title'),
      })
        .then((res) => {
          if (res === false) {
            // Closed
            return;
          }
          if (res) {
            this.editProgress = {value: 0};
            this.editInProcess = true;
            this.$store.dispatch('app/createClaimform', {
              title: res,
              items: this.checkedItems,
              progressObservable: this.editProgress
            })
              .then(() => {
                this.reloadItems();
                this.checkedItems = [];
              })
              .finally(() => {
                this.editInProcess = false;
              })
          } else {
            this.$toast(this.$t('staging.claimform.emptyName'));
          }
        })
    },

    onExcelPopupSave({ files, revoke, commit }) {
      this.uploadLoading = true;
      this.$store.dispatch('app/uploadFileToStaging', { files, revoke, commit })
        .then(() => {
          this.$toast(this.$t('staging.uploadForm.done'))
        })
        .finally(() => {
          this.uploadLoading = false;
          this.uploadPopup = false;
        })
    },

    onDownloadItems() {
      this.downloading = true
      this.$store.dispatch('app/getStagingDownloadUrl',{search: this.searchQuery, format: 'xlsx'})
        .then((res) => {
          downloadFile((res.filename ? res.filename : 'staging.xlsx'), res.url);
          this.downloading = false
        })
    },

    onCreateRightFinished(data) {
      this.onCreateRight(data)
        .then(() => {
          this.addRightVisible = false;
          this.reloadItems();
        })
    },

    onMobileExpand(item) {
      if (item.hasError) {
        this.loadErrors(item);
      }
    },

    onSpotifyPopupFinished(data) {
      this.onCreateRight(data)
        .then(() => {
          this.spotifyPopup = false;
          this.reloadItems();
        })
    },


  },
}
</script>

<style scoped>
@media (max-width: 600px) {
  .container {
    padding-bottom: 152px;
  }
}

.droparea {
  background-color: var(--color-surface-container-high) !important;
}

.sa-mobile-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 32px 16px 16px;
  background: linear-gradient(to bottom, transparent, var(--color-viewport-bg) 40%);
  z-index: 5;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sa-mobile-actions__row {
  display: flex;
  gap: 8px;
}

.sa-mobile-actions__create,
.sa-mobile-actions__import {
  flex: 1;
}
</style>